import { create } from 'zustand';
import { saveAs } from 'file-saver';
import i18n from 'i18n';
import { ApiUtils, TransactionsApi, type DownloadTransactionsRequest } from '@shared/api';
import { BaseReturn } from '@shared/types';

interface UseDownloadTransactionsStore {
  loading: boolean;
  error: string | null;
  downloadTransactions: (request: DownloadTransactionsRequest) => Promise<BaseReturn<Blob | null>>;
  clear: () => void;
}

export const useDownloadTransactionsStore = create<UseDownloadTransactionsStore>((set) => ({
  loading: false,
  error: null,

  downloadTransactions: async (request) => {
    try {
      set({ loading: true, error: null });
      const blob = await TransactionsApi.downloadTransactions(request);
      saveAs(blob, 'transactions.csv');
      set({ loading: false });
      return { loading: false, data: blob, error: null };
    } catch (error) {
      const restError = i18n.t(`errors.api.${ApiUtils.getError(error)}`, ApiUtils.getError(error));
      set({ loading: false, error: restError });
      return { loading: false, data: null, error: restError };
    }
  },

  clear: () => set({ loading: false, error: null }),
}));
